module.exports = __webpack_public_path__ + "img/introduction-devices.22683f47.png";